import { useWSModal } from "@wingspanhq/fe-component-library";
import { EditClientModal } from ".";

export const useEditClientModal = () =>
  useWSModal(EditClientModal, {
    title: "Edit client information",
    size: "S"
  });
